import { productAxiosInstance } from "@/services/axios";
import { Product } from "@/types/product";

export interface Collection {
  id: string;
  name: string;
  description?: string;
  image?: string;
  slug?: string;
  metadata?: {
    description?: string;
    meta_title?: string;
    meta_description?: string;
    meta_heading?: string;
    faq?: {
      question: string;
      answer: string;
    }[];
  };
  products?: {
    count: number;
    num_pages: number;
    current_page: number;
    results: unknown[];
  };
  content?: string;
  // Add other collection properties as needed
}

export interface CollectionsResponse {
  results: Collection[];
  next?: string;
  previous?: string;
  count: number;
}

export const getCollectionById = async (
  id: string,
  page?: number,
): Promise<Collection> => {
  const params = page ? { page } : {};
  const response = await productAxiosInstance.get(`/collections/${id}/`, {
    params,
  });
  return response.data;
};

export const getRandomProductsByCollection = async (
  collectionId: string | number,
  excludeVendorId?: number | string,
): Promise<Product[]> => {
  const params: Record<string, number | string> = {};
  if (
    excludeVendorId !== undefined &&
    excludeVendorId !== null &&
    excludeVendorId !== ""
  ) {
    params.exclude_product = excludeVendorId;
  }
  const response = await productAxiosInstance.get<Product[]>(
    `/collections/${collectionId}/random-products/`,
    {
      params,
    },
  );
  return response.data;
};
